<template>
  <div class="modalBox">
    <Card class="left">
      <p slot="title">选择</p>
      <Input
        style="margin-bottom: 15px"
        v-model="keyword"
        placeholder="搜索"
        @on-change="handlerSearchange"
      />
      <div
        v-if="this.multiple"
        style="
          border-bottom: 1px solid #e9e9e9;
          padding-bottom: 6px;
          margin-bottom: 6px;
        "
      >
        <Checkbox :value="checkAll" @click.prevent.native="handleCheckAll">
          全选
        </Checkbox>
      </div>
      <Tree
        ref="tree"
        class="demo-tree-render"
        :data.sync="list"
        :show-checkbox="multiple"
        @on-select-change="onSelectChange"
        @on-check-change="onCheckChange"
        :check-strictly="true"
      />
    </Card>
    <Card class="center"></Card>
    <Card class="right">
      <p slot="title">已选</p>
      <Row
        :gutter="24"
        class="leftContent"
        v-for="(item, index) in selectList"
        :key="item.id + index"
      >
        <Col :span="20" class="text">
          <Tooltip v-showtip placement="top" transfer>
            <div slot="content" style="white-space: normal">
              {{
                item.topTitle ? `${item.title}-${item.topTitle}` : item.title
              }}
            </div>
            <div class="ellipsis">
              <span class="ellipse-text">{{
                item.topTitle ? `${item.title}-${item.topTitle}` : item.title
              }}</span>
            </div>
          </Tooltip>
        </Col>
        <Col :span="4">
          <Icon class="cursor" type="md-close" @click="deleteItem(item)" />
        </Col>
      </Row>
    </Card>
  </div>
</template>
<script>
import _ from 'lodash';
import {
  departmentCheckedAll,
  checkAllSelect,
  getCurrentData,
  setDepartmentSelectIds,
  departmentGetSearchList,
  setItemChecked,
  myDebounce
} from '../../plugins/util';
export default {
  props: {
    // title展示
    title: {
      type: String,
      default: ''
    },
    // 是否多选  true 多选  false 单选
    multiple: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    showPath: {
      type: Boolean,
      default: true
    },
    allData: {
      type: Array,
      default: () => []
    },
    baseId: {
      type: String,
      default: ''
    },
    customTreeList: {
      type: Array,
      default: () => []
    },
    searchList: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    selectList: {
      type: Array,
      default: () => []
    },
    selectGroupIds: {
      type: Array,
      default: () => []
    },
    selectedIds: {
      type: Array,
      default: () => []
    },
    originData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      checkBoxData: [],
      activeId: '',
      keyword: '',
      checkAll: false
    };
  },
  methods: {
    handleItemClick(slectItem) {
      // 只有单选才会走这边的逻辑，多选走checkbox
      /*
        判断一下是选择部门还是选择人员
        如果是选择人员的话，但是选择的是部门的数据，就啥也不做
        如果是选择部门的话，走筛选的逻辑
      */
      if (this.type == 'person' && slectItem.isGroup) {
        return false;
      }
      // 判断是单选还是多选
      // 如果是单选的话，就替换掉
      // 如果是多选，就差看一下是否已经存在过了，如果存在过，就不再添加了，如果没有存在过，就加上
      this.checkBoxData = [slectItem.id];
    },
    deleteItem(item) {
      // 如果是多选的时候把checkbox里面的数据也给清空,因为checkBox监听操作了，不需要更改selectlist内容了
      const obj = getCurrentData(this.list, item.id);
      obj.checked = false;
      const selectedIds = this.selectedIds.filter(id => id != item.relationId);
      this.$emit('update:selectedIds', selectedIds);
      this.$emit(
        'update:selectList',
        this.selectList.filter(i => i.relationId != item.relationId)
      );
    },
    handlerSearchange: myDebounce(function() {
      const value = this.keyword;
      // this.$emit('on-input-change', value);
      const cloneDeepTree = _.cloneDeep(this.customTreeList);
      let searcheTree = setDepartmentSelectIds(
        cloneDeepTree,
        this.selectedIds,
        'relationId'
      );
      if (!value) {
        searcheTree = setDepartmentSelectIds(
          cloneDeepTree,
          this.selectedIds,
          'relationId'
        );
      } else {
        searcheTree = departmentGetSearchList(
          searcheTree,
          value,
          this.selectedIds
        );
      }
      // this.list = searcheTree;
      this.$emit('update:list', searcheTree);
    }, 500),

    handleCheckAll() {
      if (this.list.length < 1) return false;
      this.checkAll = !this.checkAll;
      // this.$emit('on-select-all', { type: this.type, checkAll: this.checkAll });
      const {
        setSelectList,
        deleteSelectList,
        addSelectList,
        result
      } = departmentCheckedAll(
        this.list,
        this.checkAll,
        this.selectList,
        'relationId'
      );
      let selectGroupIds = [];
      let selectList = [];
      if (this.checkAll) {
        selectList = setSelectList;
      } else {
        // 筛选
        const ids = deleteSelectList.map(i => i.relationId);
        selectList = setSelectList.filter(
          item => !ids.includes(item.relationId)
        );
        selectGroupIds = [];
      }
      const ids = selectList.map(i => i.relationId);
      const upDateSelectList = selectList.map(item => {
        const { id, pid, title, relationId, topTitle } = item;
        return { id, pid, title, relationId, topTitle };
      });
      this.$emit('update:selectedIds', ids);
      this.$emit('update:selectList', upDateSelectList);
    },
    onCheckChange(arr, changeItem) {
      // checked 为 true 是选中，为 false 是取消选中
      let selectedIds = [...this.selectedIds];
      if (changeItem.checked) {
        const selectList = [
          ...this.selectList,
          {
            id: changeItem.id,
            title: changeItem.title,
            pid: changeItem.pid,
            relationId: changeItem.relationId,
            topTitle: changeItem.topTitle
          }
        ];
        selectedIds = [...selectedIds, changeItem.relationId];
        this.$emit('update:selectList', selectList);
      } else {
        // 如果是单选并且是非选中，就把父级勾选取消
        // 需要把其他树节点的也选中
        selectedIds = selectedIds.filter(id => id != changeItem.relationId);
        const upDateSelectList = this.selectList
          .filter(item => item.relationId != changeItem.relationId)
          .map(i => {
            const { id, pid, title, relationId, topTitle } = i;
            return { id, pid, title, relationId, topTitle };
          });
        this.$emit('update:selectList', upDateSelectList);
      }
      this.$emit('update:selectedIds', [...new Set(selectedIds)]);
    },
    onSelectChange(arr, item) {
      if (this.multiple) return (item.selected = false);
      // 如果不需要点击每一行的就直接 把 selected 制为 false 就不会选中了
      if (!item.needSelected) return (item.selected = false);
      // 因为在点击 iview tree 为选中的时候，再次点击 tree 则会取消选中，所以在取消选中的时候再次给 selected 制为 true 此时高亮就不会消失了
      if (!item.selected) return (item.selected = true);
      this.$emit('on-select-change', { selectItem: item, type: this.type });
    }
  },
  watch: {
    selectList: {
      deep: true,
      handler(newVal, oldVal) {
        const ids = newVal.map(item => item.id);
        const customTreeList = setItemChecked(
          this.customTreeList,
          ids,
          [],
          'relationId'
        );
        this.$emit('update:customTreeList', customTreeList);
      }
    },
    list: {
      deep: true,
      immediate: true,
      handler(newVal) {
        let checkedAll = checkAllSelect(newVal);
        if (newVal.length == 0) {
          checkedAll = false;
        }
        this.checkAll = checkedAll;
      }
    }
  }
};
</script>
<style scoped>
.modalBox {
  display: flex;
  height: 400px;
}
.modalBox .left,
.modalBox .center,
.modalBox .right {
  height: 100%;
}
.left,
.right {
  width: 45%;
  overflow-y: auto;
  overflow-x: hidden;
}
.center {
  width: 10%;
}
.leftContent {
  margin: 5px 0;
}
.cursor {
  cursor: pointer;
}
.ellipsis {
  width: 255px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
